import { IClarity } from '../clarity';
import { DataLayer } from '../datalayer';
import { Gtag } from '../gtag';
import { consent } from './consent';
import { log_user_login } from './log-user-login';
import { log_user_registration } from './log-user-registration';

export type IAnalytics = ReturnType<typeof analytics_service_factory>;

export const analytics_service_factory = (datalayer: DataLayer | Error, gtag: Gtag | Error, clarity: IClarity | Error) => ({
    log_user_login: log_user_login(datalayer),
    log_user_registration: log_user_registration(datalayer),
    consent: consent(gtag, clarity),
});
